export const INVOICE_STATUS_PAID = 'Paid';
export const INVOICE_STATUS_UNPAID = 'Unpaid';

export const STATUSES_INVOINCE = [INVOICE_STATUS_PAID, INVOICE_STATUS_UNPAID];
